import { ITest, ISectionConfig, ITestElement } from "@/modules/assessments/types/test.interface";
import { sectionsTimeSum } from "@/modules/tables/tables.utils";

const startsSection = (
  element: ITestElement,
): element is ITestElement & { config: ITestElement["config"] & { startsSection: ISectionConfig } } =>
  Boolean(element.config?.startsSection);

/**
 * Sums all section time limits in a test. Returns minutes (matches `ISectionConfig.timeLimit`),
 * not milliseconds — do not confuse with `test.config.suggestedTime`.
 */
export function getTestSectionsTimeSum(test: ITest): number {
  const sections = (test.testElements ?? []).filter(startsSection).map((element) => element.config.startsSection);
  return sectionsTimeSum(sections);
}
